/**
 * These events are sent from Mobile Apps to Web
 * @type {{INVOKE_SIGNOUT_BTN_ACTION: string, INVOKE_LOGOUT: string, TOGGLE_LOCALE_SELECTOR: string, SHOW_ZENDESK_DIALOG: string, HANDLE_POST_LOGIN_LOCATIONS: string, GOTO_BETHISTORY: string, GOTO_BETSLIP: string, GO_BACK: string, INVOKE_PANIC_CONFIRM: string, VALIDATE_SESSION: string, HANDLE_LOGIN_SUCCESS: string, HISTORY_GO_TO:string}}
 */
export const APP_EVENTS = {
	HISTORY_REPLACE: 'ReplaceWebPath',
	HISTORY_PUSH: 'PushWebPath',
	HISTORY_UPDATE: 'UpdateWebPath', // planned to be removed
	TOGGLE_LOCALE_SELECTOR: 'toggleLocaleSelector',
	HANDLE_LOGIN_SUCCESS: 'handleLoginSuccess',
	INVOKE_LOGOUT: 'invokeLogout',
	INVOKE_PANIC_CONFIRM: 'invokePanicConfirm',
	HANDLE_POST_LOGIN_LOCATIONS: 'handlePostLoginLocations',
	INVOKE_SIGNOUT_BTN_ACTION: 'invokeSignoutBtnAction',
	VALIDATE_SESSION: 'validateSession',
	GO_BACK: 'goBack',
	HISTORY_GO_TO: 'goToHistory',
	GOTO_BETSLIP: 'SB_Goto_Betslip',
	GOTO_BETHISTORY: 'SB_Goto_BetHistory',
	NAVIGATE_TO_SPORTSBOOK: 'navigateToSportsbook',
	NAVIGATE_TO_LIVE_BETTING: 'navigateToLiveBetting',
	CLOSE_LOSSLIMITS_MESSAGE: 'closeLossLimitsMessage',
	COMPLETE_TEMP_PLAYER_VERIFICATION: 'CompleteTemporaryPlayerVerification',
	ACCOUNT_UPDATE: 'AccountUpdate',
	COMPLETE_MITID_VERIFICATION: 'CompleteMitIDVerification',
	LOCATIONSMART_EVENT_STREAM_WRAPPER: 'LocationSmartEventStreamWrapper',
	CLOSE_HIGHLIGHTGAMES_ONBOARDING: 'CloseHighlightGamesOnboarding',
	SET_WELCOME_SCREEN_SHOWN: 'welcomeScreenHasBeenShown',
	CLOSE_WIN_ANIMATION: 'closeWinAnimation',
	WEBSOCKET_MESSAGE: 'websocketMessage',
	START_REALITY_CHECK: 'StartRealityCheck',
	TOGGLE_SPLASHTECH: 'ToggleSplashTech',
	CLOSE_LIMIT_MODAL: 'closeLimitModal',
	TOGGLE_SUPPORT: 'ToggleSupport',
	INVOKE_AUTHENTICATION: 'invokeAuthentication'
};

/**
 * These events are sent from Web to Mobile Apps
 * @type {{LOGOUT: string, BRIDGE_INIT: string, REALITY_CHECK_POPUP: string, PAYMENT_RESULT_CLOSED: string, GAME_STATES: {GameReady: string, RoundStarted: string}, BETSLIP_UPDATED: string, LOGIN_FORM_OPENED: string, GET_APP_INFO: string, ON_HEADER_UPDATE: string, UPDATE_UNREAD_NOTIF_COUNT: string, REGISTRATION_COMPLETE: string, POST_LOGIN_DONE: string, ON_SHOW_HISTORY_FROM_RC: string, LOGIN: string, UPDATE_CASINO_NET_POSITION: string, DEGA_AUTOWITHDRAW_POPUP: string, SHOW_GAMEPLAY_BLOCK_MESSAGE: string, LIMIT_MODAL_CLOSED: string}}
 */
export const WEB_EVENTS = {
	BRIDGE_INIT: 'BridgeINIT',
	GET_APP_INFO: 'GetAppInfo',
	LOGIN_FORM_OPENED: 'LoginFormOpened', // planned to be removed
	LOGIN: 'Login',
	LOGOUT: 'Logout',
	REGISTRATION_COMPLETE: 'RegistrationComplete',
	WITHDRAW_COMPLETE: 'WithdrawComplete',
	PAYMENT_RESULT_CLOSED: 'paymentResultClosed',
	ON_SHOW_HISTORY_FROM_RC: 'onShowHistoryFromRC',
	ON_HEADER_UPDATE: 'onHeaderUpdate',
	GAME_STATES: { GameReady: 'GameReady', RoundStarted: 'GameRoundStarted' },
	UPDATE_UNREAD_NOTIF_COUNT: 'updateUnreadNotifCount',
	POST_LOGIN_DONE: 'postLoginDone',
	UPDATE_CASINO_NET_POSITION: 'updateCasinoNetPosition',
	BETSLIP_UPDATED: 'SB_BETSLIP_UPDATED',
	BALANCE_UPDATED: 'BalanceUpdated',
	OPEN_BETS_UPDATED: 'SB_OPEN_BETS_UPDATED',
	IS_AADHAAR_VERIFIED: 'isAadhaarVerified',
	IS_NEMID_JUST_VERIFIED: 'isNemIDJustVerified',
	AUTH_STATUS_CHANGED: 'AuthStatusChanged',
	SESSION_TERMINATED: 'SessionTerminated',
	ENCRYPTED_PID_UPDATED_FOR_EV: 'EncryptedPidUpdatedForEV', // for ExtendedVerification
	// Regulations
	REALITY_CHECK_POPUP: 'RealityCheckPopup',
	LOSS_LIMITS_MESSAGE: 'LossLimitsMessageUpdate',
	DEGA_AUTOWITHDRAW_POPUP: 'DegaAutoWithdrawPopup',
	ACCOUNT_VERIFICATION_SUCCESS: 'AccountVerificationSuccess',
	LIMIT_MODAL_CLOSED: 'SpendingLimitModalClosed',
	MITID_LOGIN_URL: 'MitIDLoginUrl',
	// Location Smart
	LOCATION_SMART_COMPLETED: 'LocationSmartCompleted',
	// Game Window
	IS_WIN_ANIMATION_SHOWN: 'IsWinAnimationShown',
	SOW_UPLOAD_SUCCESSFUL: 'SowUploadSuccessful',
	IS_SPLASHTECH_SHOWN: 'IsSplashTechShown',
	PLAYER_LIMITS_UPDATED: 'PlayerLimitsUpdated',
	SHOW_GAMEPLAY_BLOCK_MESSAGE: 'ShowGamePlayBlockMessage',
	GAME_PLAY_STARTED: 'GamePlayStarted',
	SHOW_REALTIME_MENTOR_MESSAGE: 'ShowRealtimeMentorMessage',
	SHOW_NOTIFICATION: 'ShowNotification',
	LOG_EVENT: 'LOG_EVENT',
	IS_SUPPORT_DIALOG_SHOWN: 'IsSupportDialogShown'
};

export const GAMEPLAY_BLOCK_TYPES = {
	NOT_ALLOWED: 'NotAllowed',
	PRODUCT_BLOCKED: 'ProductBlocked'
};

export const NOTIFICATION_TYPE = {
	ACCOUNT_ALREADY_SUSPENDED: 'ACCOUNT_ALREADY_SUSPENDED',
	LIMITED_BALANCE_AUTO_WD: 'LIMITED_BALANCE_AUTO_WD',
	CDDN_REGISTER_ERROR: 'CDDN_REGISTER_ERROR',
	ACCOUNT_SUSPENDED_WITH_NON_RESPONSIBLE_REASON: 'ACCOUNT_SUSPENDED_WITH_NON_RESPONSIBLE_REASON',
	ACCOUNT_SUSPENDED_WITH_RESPONSIBLE_REASON: 'ACCOUNT_SUSPENDED_WITH_RESPONSIBLE_REASON',
	SPENDING_LIMIT: 'SPENDING_LIMIT',
	SPENDING_LIMIT_WITH_DEPOSIT_BUTTON: 'SPENDING_LIMIT_WITH_DEPOSIT_BUTTON',
	GENERAL_ERROR: 'GENERAL_ERROR'
};

export const AUTHENTICATION_TYPE = {
	LOGIN: 'login',
	REGISTER: 'register'
};
